import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

const kitThresholdServices = {
	gateway,
	updateKitThreshold,
};

function gateway({ req, method }) {
	switch (method) {
		case 'LIST_DATA':
			return fetchKitThresholdList(req);
		default:
			break;
	}
	return new Promise();
}

/**
 * Kit thresholds for a store.
 * @param {Object} req - { params: { storeId, productType, configuredOnly } }
 */
function fetchKitThresholdList(req = {}) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.KIT_THRESHOLD_LIST, params);
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};

	return fetch(url, requestOptions).then(handleResponse);
}

/**
 * Upsert kit counts. Create and update are the same call — the grid does not
 * know which cells already have a row behind them.
 * @param {Object} req - { data: { storeId, editValues: { [productId]: { [variantId]: kits } } } }
 */
function updateKitThreshold(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(endpoints.KIT_THRESHOLD_UPDATE, requestOptions).then(
		handleResponse
	);
}

export default kitThresholdServices;
